import React from "react";
import Header from "./views/Header";
import { AuthContext } from "./context/AuthContext";

function App() {
  return (
    <AuthContext>
      <Header />
    </AuthContext>
  );
}
export default App;
